var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('p',{staticClass:"font-weight-bold text-center"},[_vm._v("Регистрация в программе лояльности")]),_c('Mir')],1)}
var staticRenderFns = []

export { render, staticRenderFns }